<p-toast></p-toast>
<p-card *ngIf="verified; else noaccess" class="form-wrapper">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">
    <p-tabPanel header="New Fixed Reservation">
      <div class="p-fluid">
        <div class="p-field mb-3 username-field">
          <label for="username">Username</label>
          <div class="username-input-wrapper">
            <span class="at-prefix">&#64;</span>
            <input
              id="username"
              type="text"
              pInputText
              placeholder="username"
              [(ngModel)]="username"
              (input)="searchUsers(username)"
            />
          </div>
          <ul *ngIf="filteredUsers.length" class="suggestions-list">
            <li *ngFor="let s of filteredUsers" (click)="selectSuggestion(s)">
              &#64;{{ s }}
            </li>
          </ul>
        </div>
        <div class="p-field mb-3">
          <label for="day">Day</label>
          <p-dropdown
            id="day"
            [options]="days"
            [(ngModel)]="selectedDay"
            placeholder="Select day"
            (onChange)="onDayChange()"
          ></p-dropdown>
        </div>
        <div class="p-field mb-3">
          <label for="time">Time</label>
          <p-dropdown
            id="time"
            [options]="times"
            [(ngModel)]="selectedTime"
            placeholder="Select time"
          ></p-dropdown>
        </div>
        <div class="p-field mb-3">
          <label for="duration">Duration</label>
          <p-dropdown
            id="duration"
            [options]="durationOptions"
            [(ngModel)]="selectedDuration"
            placeholder="Select duration"
          ></p-dropdown>
        </div>
        <div class="p-field mb-3">
          <label for="court">Court</label>
          <p-dropdown
            id="court"
            [options]="courts"
            optionLabel="name"
            [(ngModel)]="selectedCourt"
            placeholder="Select court"
          ></p-dropdown>
        </div>
        <div class="p-field mb-3">
          <label for="months">Months</label>
          <p-dropdown
            id="months"
            [options]="monthsOptions"
            [(ngModel)]="selectedMonths"
            placeholder="Months"
          ></p-dropdown>
        </div>
        <div class="p-field mb-3 d-flex align-items-center">
          <button
            pButton
            type="button"
            label="Check availability"
            (click)="checkAvailability()"
            [disabled]="loading"
          ></button>
          <p-progressSpinner
            *ngIf="loading"
            styleClass="ms-2"
            strokeWidth="4"
            diameter="25"
          ></p-progressSpinner>
        </div>
        <div *ngIf="checked" class="availability-results">
          <div *ngIf="unavailable.length > 0">
            <p>Unavailable dates:</p>
            <ul>
              <li *ngFor="let d of unavailable">
                {{ d | date: 'fullDate' }} {{ selectedTime }}:00
              </li>
            </ul>
          </div>
          <div *ngIf="unavailable.length === 0">
            <p>All dates are available.</p>
            <p>Price per booking: {{ slotPrice }} RSD</p>
            <p>Total price: {{ totalPrice }} RSD</p>
            <button pButton type="button" label="Book" (click)="book()"></button>
          </div>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Manage Fixed Reservations">
      <div class="p-field mb-3">
        <input
          type="text"
          pInputText
          placeholder="Search by user"
          [(ngModel)]="searchTerm"
          (input)="applySeriesFilter()"
        />
      </div>
      <p-table [value]="filteredReservations">
        <ng-template pTemplate="header">
          <tr>
            <th>Fixed Start Date</th>
            <th>End Fixed Date</th>
            <th>Fixed Reservation Duration (months)</th>
            <th>Court</th>
            <th>User</th>
            <th>Fixed Series ID</th>
            <th>Players</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-res>
          <tr (click)="showSeriesInfo()" style="cursor: pointer">
            <td>{{ res.fixedStart | date: 'yyyy-MM-dd HH:mm' }}</td>
            <td>{{ res.fixedEnd | date: 'yyyy-MM-dd HH:mm' }}</td>
            <td>{{ res.durationMonths }}</td>
            <td>{{ res.courtName }}</td>
            <td>{{ res.booking_user }}</td>
            <td>{{ res.fixed_series_id }}</td>
            <td>
              {{ getPlayerNames(res) }}
            </td>
            <td>
              <button
                *ngIf="canDelete(res)"
                pButton
                type="button"
                icon="pi pi-trash"
                (click)="deleteSeries(res); $event.stopPropagation()"
              ></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
    <p-tabPanel header="Manage Individual Fixed Book">
      <div class="p-field mb-3">
        <input
          type="text"
          pInputText
          placeholder="Search by user"
          [(ngModel)]="userFilter"
          (input)="applyIndividualFilter()"
        />
      </div>
      <div class="p-field mb-3">
        <input
          type="text"
          pInputText
          placeholder="Search by series id"
          [(ngModel)]="seriesFilter"
          (input)="applyIndividualFilter()"
        />
      </div>
      <p-table
        [value]="filteredIndividualReservations"
        [sortField]="'reservation_start_time'"
        [sortOrder]="1"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="reservation_start_time">
              Date
              <p-sortIcon field="reservation_start_time"></p-sortIcon>
            </th>
            <th>Fixed Start Date</th>
            <th>End Fixed Date</th>
            <th>Fixed Reservation Duration (months)</th>
            <th>Court</th>
            <th>User</th>
            <th>Fixed Series ID</th>
            <th>Players</th>
            <th>Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-res>
          <tr>
            <td>{{ res.reservation_start_time | date: 'yyyy-MM-dd HH:mm' }}</td>
            <td>{{ res.fixedStart | date: 'yyyy-MM-dd HH:mm' }}</td>
            <td>{{ res.fixedEnd | date: 'yyyy-MM-dd HH:mm' }}</td>
            <td>{{ res.durationMonths }}</td>
            <td>{{ res.courtName }}</td>
            <td>{{ res.booking_user }}</td>
            <td>{{ res.fixed_series_id }}</td>
            <td>{{ getPlayerNames(res) }}</td>
            <td>
              <button
                *ngIf="canModifyPlayers(res)"
                pButton
                type="button"
                icon="pi pi-users"
                label="Players"
                class="me-1"
                (click)="openPlayerDialog(res)"
              ></button>
              <button
                *ngIf="canCancel(res)"
                pButton
                type="button"
                icon="pi pi-times"
                (click)="cancelReservation(res)"
              ></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
  </p-tabView>
</p-card>
<ng-template #noaccess>
  <p>You do not have access to this page.</p>
</ng-template>

<p-dialog header="Information" [(visible)]="infoDialogVisible" [modal]="true">
  <p>
    To delete individual bookings for a fixed reservation, go to the Court
    Bookings option in the employee interface and deny the booking with the X
    button, providing a reason.
  </p>
</p-dialog>

<p-dialog
  header="Manage Players"
  [(visible)]="playerDialogVisible"
  [modal]="true"
  [style]="{ width: '30rem' }"
  [appendTo]="'body'"
  (onHide)="selectedReservation = null"
>
  <div *ngIf="selectedReservation">
    <ul style="max-height: 200px; overflow-y: auto;">
      <li *ngFor="let p of selectedReservation.courtReservationPlayer">
        {{ p.player?.full_name }}
        <button
          *ngIf="p.player_id !== selectedReservation.user_id"
          pButton
          type="button"
          icon="pi pi-minus"
          class="ms-2"
          (click)="removePlayer(p.player_id)"
        ></button>
      </li>
    </ul>
    <div class="p-field mt-3">
      <p-autoComplete
        [(ngModel)]="newPlayer"
        [suggestions]="playerSuggestions"
        (completeMethod)="searchPlayers($event)"
        field="label"
        [dropdown]="true"
        [forceSelection]="true"
        placeholder="Search player"
        [appendTo]="'body'"
      ></p-autoComplete>
      <button
        pButton
        type="button"
        label="Add"
        class="ms-2"
        (click)="addPlayer()"
      ></button>
    </div>
  </div>
</p-dialog>

